import type { Components, Theme } from '@mui/material/styles';

const MuiTooltip: Components<Theme>['MuiTooltip'] = {
  styleOverrides: {
    /**
     * Корневые стили табов
     */
    tooltip: () => ({
      fontSize: 12,
      lineHeight: 1.17
    })
  }
};

export const tooltip = {
  MuiTooltip
};
